import IPercentualTransferenciaMotorista from '../entities/IPercentualTransferenciaMotorista'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IUpdatePercentualTransferenciaMotorista {
  execute(data: IPercentualTransferenciaMotorista): Promise<void>
}

export default class UpdatePercentualTransferenciaMotoristaImpl
  implements IUpdatePercentualTransferenciaMotorista
{
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(data: IPercentualTransferenciaMotorista): Promise<void> {
    return this.pagamentoRepository.update(data)
  }
}
